var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"width":"28px","height":"28px"},attrs:{"src":require("@/assets/images/sortIcon.svg")}})}
var staticRenderFns = []

export { render, staticRenderFns }